// Shared selection state only. Each wall owns the numeric base and relaxed
// caps in its own reward unit and resolves the effective max from this level.
export type WallRewardCapLevel = "base" | "relaxed";

export const DEFAULT_WALL_REWARD_CAP_LEVEL: WallRewardCapLevel = "base";

// Upper bound currently in force for a single wall's reward value.
//
// "Effective" means the bound that applies right now, not a base constant.
// Each wall resolves its effective max through its own
// `resolve*RewardEffectiveMax*` helper and clamps the reward with that same
// value. A reward that stays at the previous bound stops reporting `reached`
// when the level changes, and reports `reached` again once it climbs to the
// new bound.
//
// Consumers must read `reached` from here instead of comparing a reward value
// against a wall-specific constant.
export interface WallRewardEffectiveCap {
  readonly effectiveMaxValue: number;
  readonly reached: boolean;
}

export function resolveWallRewardEffectiveCap(
  value: number,
  effectiveMaxValue: number,
): WallRewardEffectiveCap {
  return {
    effectiveMaxValue,
    reached: Number.isFinite(effectiveMaxValue) && value >= effectiveMaxValue,
  };
}
